import { render, staticRenderFns } from "./BookingOverviewCalendar.vue?vue&type=template&id=22450c58&scoped=true&"
import script from "./BookingOverviewCalendar.vue?vue&type=script&lang=js&"
export * from "./BookingOverviewCalendar.vue?vue&type=script&lang=js&"
import style0 from "./BookingOverviewCalendar.vue?vue&type=style&index=0&id=22450c58&prod&scoped=true&lang=scss&"
import style1 from "./BookingOverviewCalendar.vue?vue&type=style&index=1&id=22450c58&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22450c58",
  null
  
)

export default component.exports